import { useMemo, type ReactNode } from "react";
import { SharedApiContext, type SharedApiContextValue } from "../shared-api/shared-api-context";

type SharedApiProviderProps = SharedApiContextValue & {
  children: ReactNode;
};

/**
 * Provides the app's API clients (configuration + file) to shared hooks/components.
 * Each app creates its own clients via `@repo/services` factories (with its own base
 * URLs) and injects them here, so shared API hooks stay decoupled from app singletons.
 */
export const SharedApiProvider = ({
  configurationApi,
  fileApi,
  children,
}: SharedApiProviderProps) => {
  const value = useMemo(() => ({ configurationApi, fileApi }), [configurationApi, fileApi]);

  return <SharedApiContext.Provider value={value}>{children}</SharedApiContext.Provider>;
};
